import React from "react"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { CustomServerSideReactTableNew } from "components/utility"
import { areaTypes, findTypeValueByKey } from "utils/types"
import { getImportTypeDefinition } from "utils/dataImportType"
import { GET_TABLE_FIELDS } from "../../order-query/gql"
import { GET_COMPANIES, DELETE_COMPANY, SUM_COMPANIES } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const CompanyListContainer = (props) => {
  useBread({ to: props.match.url, name: "公司清單" }, true)

  const columnDefs = [
    { title: "公司名稱", name: "name", type: "input" },
    { title: "公司統編", name: "companyNumber", type: "input" }
  ]

  const fieldsDefinition = () => {
    return [
      {
        id: "name",
        Header: "名稱",
        style: columStyle,
        accessor: "name",
        width: 200
      },
      {
        id: "area",
        Header: "區域",
        style: columStyle,
        width: 100,
        accessor: (data) => findTypeValueByKey(areaTypes, data.area)
      },
      {
        id: "address",
        Header: "地址",
        style: columStyle,
        accessor: "address"
      },
      {
        id: "companyNumber",
        Header: "統編",
        style: columStyle,
        width: 100,
        accessor: "companyNumber"
      },
      {
        id: "phoneNumber",
        Header: "電話",
        style: columStyle,
        width: 100,
        accessor: "phoneNumber"
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      objectName="公司"
      columnDefs={columnDefs}
      objectRoute={props.match.url}
      queryObjectGql={GET_COMPANIES}
      fieldsDefGql={GET_TABLE_FIELDS}
      sumTotalQueryObjectGql={SUM_COMPANIES}
      hasEditButton={true}
      hasCreateButton={true}
      hasUploadButton={true}
      fieldsDef={fieldsDefinition(props)}
      uploadSettings={getImportTypeDefinition("COMPANY")}
    />
  )
}
const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(CompanyListContainer)
